import React, { Component } from 'react';
import {Row, Col} from 'react-bootstrap';
import classes from './previewTemplate.module.css'
import ReusablePreview from './Reusable_Preview'
class previewTemplate extends Component {
    render() {
       
        return (
            <>
           
        <Row className={classes.gapTop}>
                      <Col md={12}>
                      <fieldset className={classes.schedulerBorder}>  
                      <legend className={classes.schedulerBorder}>Invite Details</legend>
                    
                      <ReusablePreview
                            candidateId={this.props.candidateId}
                            endTime={this.props.endTime}
                            interviewDate={this.props.interviewDate}
                            interviewerId={this.props.interviewerId}
                            interviewerNotes={this.props.interviewerNotes}
                            jobProfileId={this.props.jobProfileId}
                            startTime={this.props.startTime}
                            availability={this.props.availability}
                            selecttypeofInterviewValue={this.props.selecttypeofInterviewValue}
                      /> 
                    
                        <Row>
                            <Col md={12}>
                                <h5 className={classes.interview} >Invite to Interviewer</h5>
                                <p>Dear <b>Evaluator</b>,</p>
              
               <p>
               An interview scheduling request has been sent to you. Kindly accept the request on our mobile application.
                    </p>
                    <p><b>Details of the interview:</b></p>
                  <p>  Date of Interview - {this.props.interviewDate}<br/>
                    Time of Interview - {this.props.startTime}<br/>
                    Position - {this.props.jobProfileId.jobtitle}<br/>
                    Interview Mode - {this.props.selecttypeofInterviewValue}
                    
                    </p>

                    {this.props.selecttypeofInterviewValue=="Video"?<>
                        <p>
                        Video URL - [URL will be generated after sending invite]
                        </p>
                    <p>
                  Please use the above link to start the video call. Kindly make sure that you have access to camera and internet for the video call.
                        </p></>:null}
                        
                   <p>
                   Regards,<br/>
                   FoxMatrix Operations Team
                   </p>

               
                {/* {this.props.interviewerNotes?<p>Additional notes: {this.props.interviewerNotes}</p>:null} */}
     
                            </Col>
                        </Row>


                        <Row>
                            <Col md={12}>
                                <h5 className={classes.interview} >Invite to Candidate</h5>
                                <p>Dear <b>Candidate</b>,</p>
                  <p>
                  An interview has been scheduled with you. Details of the interview:
                    </p>
                  <p>
                  Company - { this.props.companyName!=null?this.props.companyName:"Company name not available"}<br/>
                  Position - {this.props.jobProfileId.jobtitle}<br/>
                  Date of Interview - {this.props.interviewDate}<br/>
                  Time of Interview - {this.props.startTime}<br/>
                  Interview mode - {this.props.selecttypeofInterviewValue}
                    </p>
                   
                    {this.props.selecttypeofInterviewValue=="Telephonic"?
                    <p>
                   You will get a call at the time of the interview. Please make yourself available for the same.
                        </p>:null}

                        {this.props.selecttypeofInterviewValue=="Video"?<>
                        <p>
                        Video URL - [URL will be generated after sending invite]
                        </p>
                    <p>
                  Please use the above link to start the video call. Kindly make sure that you have access to camera and internet for the video call.
                        </p></>:null}

                        {this.props.selecttypeofInterviewValue=="Face to Face"?<>
                        <p>
                        Venue: [venue]
                    </p>
                    <p>
                  Please visit the above venue for face to face interview on the specified date & time.
                        </p></>:null}

                        <p>
                   Regards,<br/>
                   FoxMatrix Operations Team
                   </p>
                {/* {this.props.candidateNotes?<p>Additional notes: {this.props.candidateNotes}</p>:null} */}
                            </Col>
                        </Row>
                    </fieldset>
                    </Col>
                    </Row>
        </>
        );
    }
}

export default previewTemplate;